import { render, staticRenderFns } from "./DevelopmentFullTransactions.vue?vue&type=template&id=0484f8e8"
import script from "./DevelopmentFullTransactions.vue?vue&type=script&lang=js"
export * from "./DevelopmentFullTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports